var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgOrganisation = function SvgOrganisation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "organisation_svg__a",
    width: 32,
    height: 32,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h32v32H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#organisation_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M15.998 29.221q-1.933 0-3.268-1.334-1.335-1.336-1.334-3.268 0-1.656 1.02-2.896a4.55 4.55 0 0 1 2.582-1.591v-3.129H9.742a2.32 2.32 0 0 1-1.702-.707 2.32 2.32 0 0 1-.708-1.703V11.94H5.268q-.513 0-.859-.346a1.17 1.17 0 0 1-.346-.859V4.611q0-.52.346-.865t.859-.345h6.123q.52 0 .865.347.345.346.345.858v6.123q0 .52-.347.866-.346.344-.858.344H9.332v2.654a.4.4 0 0 0 .115.295.4.4 0 0 0 .295.116h12.513a.4.4 0 0 0 .295-.116.4.4 0 0 0 .115-.295v-2.769a4.55 4.55 0 0 1-2.582-1.591q-1.02-1.24-1.02-2.896 0-1.933 1.334-3.268 1.336-1.335 3.268-1.335 1.933 0 3.268 1.335 1.335 1.336 1.334 3.268 0 1.656-1.02 2.896a4.55 4.55 0 0 1-2.582 1.591v2.77a2.32 2.32 0 0 1-.708 1.702 2.32 2.32 0 0 1-1.702.707h-5.257v3.129a4.55 4.55 0 0 1 2.582 1.59q1.02 1.24 1.02 2.897 0 1.933-1.334 3.268-1.336 1.335-3.268 1.334"
  }))));
};
export default SvgOrganisation;